<template>
    <vue-scroll>
        <div class="page-header">
            <h1>Community Logs</h1>
        </div>
        <div class="clearfix"></div>
        <el-table
            :data="logs.data"
            row-key="id"
            ref="table"
            v-loading="logs.meta.loading"
        >
            <el-table-column label="User">
                <template slot-scope="{ row }">
                    {{ row.user ? row.user.name : "" }}
                </template>
            </el-table-column>
            <el-table-column label="Status">
                <template slot-scope="{ row }">
                    {{ row.data.status }}
                </template>
            </el-table-column>
            <el-table-column label="Time">
                <template slot-scope="{ row }">
                    {{ row.created_at | florida_short_datetime }}
                </template>
            </el-table-column>
        </el-table>
        <app-pagination
            :pagination="logs.meta.pagination"
            @current-change="onPageChange"
            class="mt-10"
        />
        <div class="clearfix"></div>
    </vue-scroll>
</template>
<script>
import backend_paginator from "@/mixins/backend-paginator";
import auth from "@/mixins/auth";
export default {
    mixins: [backend_paginator, auth],
    data() {
        return {
            logs: {
                data: [],
                meta: {
                    pagination: null,
                    loading: false,
                },
            },
        };
    },
    mounted() {
        this.getAuditLogs();
    },
    computed: {
        //
    },
    methods: {
        getAuditLogs(page = 1) {
            let community_id = parseInt(this.$router.history.current.params.id);
            this.logs.meta.loading = true;
            axios
                .get(`/web-api/audit-log`, {
                    params: {
                        include: "user",
                        model_type: "App\\Community",
                        model_id: community_id,
                        type: "community logging",
                        page,
                    },
                })
                .then((response) => {
                    this.logs.data = response.data.data;
                    this.logs.meta.pagination = response.data.meta.pagination;
                })
                .finally(() => (this.logs.meta.loading = false));
        },
        onPageChange(page) {
            this.getAuditLogs(page);
        },
    },
};
</script>
<style lang="scss" scoped>
//
</style>
